export const navLinks = [
  { label: '首页', href: '/' },
  { label: '游戏素材', href: '/category/game-assets' },
  { label: '音效资源', href: '/category/sound-effects' },
  { label: '音乐素材', href: '/category/music' },
  { label: '视觉素材', href: '/category/visual-assets' },
  { label: '文章资讯', href: '/articles' },
  { label: '关于我们', href: '/about' },
];

export const heroSlides = [
  {
    title: '海量游戏素材，一站获取',
    subtitle: '超过50万款高质量游戏开发素材，涵盖2D/3D模型、UI界面、粒子特效等，全部免费下载',
    btnText: '探索素材库',
    btnLink: '/category/game-assets',
    image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20and%20colorful%20digital%20art%20collage%20featuring%20game%20development%20assets%20like%202D%20character%20sprites%2C%203D%20models%2C%20UI%20elements%2C%20and%20particle%20effects%20on%20a%20dark%20warm%20gradient%20background%2C%20creative%20and%20dynamic%20composition%2C%20modern%20game%20design%20aesthetic%2C%20soft%20glow%20effects%2C%20high%20detail%2C%20cinematic%20lighting&width=1600&height=800&seq=hero-slide-01&orientation=landscape',
  },
  {
    title: '专业音效库，让游戏活起来',
    subtitle: '上万款高品质音效素材，涵盖战斗、环境、UI交互等多种场景，即搜即用',
    btnText: '浏览音效库',
    btnLink: '/category/sound-effects',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20sound%20wave%20visualization%20with%20warm%20orange%20and%20teal%20color%20gradients%2C%20music%20studio%20atmosphere%20with%20soft%20ambient%20lighting%2C%20audio%20engineering%20concept%20art%2C%20clean%20minimalist%20design%20with%20geometric%20patterns%2C%20modern%20digital%20audio%20aesthetic&width=1600&height=800&seq=hero-slide-02&orientation=landscape',
  },
  {
    title: '背景音乐，营造沉浸氛围',
    subtitle: '丰富的BGM资源库，从史诗战斗到温馨村庄，各类风格音乐任你挑选',
    btnText: '发现音乐',
    btnLink: '/category/music',
    image: 'https://readdy.ai/api/search-image?query=Ethereal%20musical%20landscape%20with%20floating%20notes%20and%20instruments%2C%20warm%20golden%20and%20emerald%20color%20palette%2C%20magical%20atmosphere%20with%20soft%20glowing%20particles%2C%20fantasy%20game%20background%20style%2C%20dreamy%20and%20immersive%20visual%20design&width=1600&height=800&seq=hero-slide-03&orientation=landscape',
  },
];

export const stats = [
  { value: '500,000+', label: '素材资源' },
  { value: '1,200,000+', label: '注册用户' },
  { value: '98%', label: '用户好评率' },
  { value: '50+', label: '素材分类' },
];

export const categories = [
  {
    slug: 'game-assets',
    name: '游戏素材',
    icon: 'ri-gamepad-line',
    description: '2D/3D模型、UI界面、粒子特效、角色立绘',
    count: 128000,
    color: 'primary',
    image: 'https://readdy.ai/api/search-image?query=Colorful%202D%20game%20character%20sprites%20and%20UI%20elements%20arranged%20on%20a%20clean%20warm%20background%2C%20game%20development%20assets%20showcase%2C%20bright%20and%20vibrant%20colors%2C%20organized%20layout%2C%20professional%20game%20design%20aesthetic&width=600&height=400&seq=cat-game-assets&orientation=landscape',
  },
  {
    slug: 'sound-effects',
    name: '音效资源',
    icon: 'ri-volume-up-line',
    description: '战斗音效、UI音效、环境音、角色语音',
    count: 95000,
    color: 'accent',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20sound%20design%20concept%20with%20waveform%20patterns%20and%20audio%20equipment%2C%20warm%20teal%20and%20amber%20color%20scheme%2C%20clean%20modern%20studio%20background%2C%20professional%20audio%20production%20aesthetic%2C%20minimalist%20design&width=600&height=400&seq=cat-sound-effects&orientation=landscape',
  },
  {
    slug: 'music',
    name: '音乐素材',
    icon: 'ri-music-line',
    description: '背景音乐、主题曲、氛围音乐、战斗BGM',
    count: 45000,
    color: 'secondary',
    image: 'https://readdy.ai/api/search-image?query=Musical%20composition%20scene%20with%20sheet%20music%20and%20warm%20golden%20lighting%2C%20elegant%20classical%20instruments%20silhouette%2C%20soft%20ambient%20atmosphere%2C%20creative%20music%20production%20concept%2C%20warm%20amber%20tones&width=600&height=400&seq=cat-music&orientation=landscape',
  },
  {
    slug: 'visual-assets',
    name: '视觉素材',
    icon: 'ri-image-line',
    description: '纹理贴图、概念原画、图标集、字体设计',
    count: 82000,
    color: 'primary',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20display%20of%20textures%20patterns%20and%20concept%20art%20on%20a%20clean%20warm%20background%2C%20various%20design%20elements%20like%20icons%20and%20typography%2C%20creative%20visual%20design%20showcase%2C%20warm%20orange%20and%20neutral%20tones&width=600&height=400&seq=cat-visual-assets&orientation=landscape',
  },
];

export const featuredAssets = [
  {
    id: 1,
    title: '像素风角色精灵包',
    category: 'game-assets',
    categoryName: '游戏素材',
    downloads: 28400,
    rating: 4.8,
    format: 'PNG/PSD',
    size: '256MB',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20pixel%20art%20character%20spritesheet%20with%20various%20poses%20and%20animations%20on%20a%20clean%20neutral%20background%2C%20retro%20game%20style%2C%20vibrant%20colors%2C%20organized%20grid%20layout&width=400&height=300&seq=asset-pixel-char&orientation=landscape',
  },
  {
    id: 2,
    title: '史诗战斗音效合集',
    category: 'sound-effects',
    categoryName: '音效资源',
    downloads: 19200,
    rating: 4.9,
    format: 'WAV/MP3',
    size: '1.2GB',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20sound%20wave%20visualization%20with%20intense%20energy%2C%20abstract%20audio%20spectrum%20in%20warm%20orange%20and%20teal%20colors%2C%20cinematic%20sound%20design%20concept%2C%20dark%20background%20with%20glowing%20elements&width=400&height=300&seq=asset-epic-sound&orientation=landscape',
  },
  {
    id: 3,
    title: '奇幻RPG背景音乐包',
    category: 'music',
    categoryName: '音乐素材',
    downloads: 15600,
    rating: 4.7,
    format: 'MP3/FLAC',
    size: '890MB',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20musical%20landscape%20with%20golden%20notes%20floating%20over%20a%20magical%20forest%20scene%2C%20warm%20amber%20lighting%2C%20orchestral%20music%20concept%2C%20epic%20and%20atmospheric%2C%20soft%20glow%20effects&width=400&height=300&seq=asset-rpg-music&orientation=landscape',
  },
  {
    id: 4,
    title: '科幻UI界面素材包',
    category: 'game-assets',
    categoryName: '游戏素材',
    downloads: 22300,
    rating: 4.6,
    format: 'PSD/Sketch',
    size: '420MB',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20game%20UI%20interface%20design%20elements%20on%20a%20dark%20background%2C%20holographic%20panels%20and%20buttons%2C%20cyan%20and%20orange%20accents%2C%20clean%20modern%20HUD%20design%2C%20professional%20game%20UI%20aesthetic&width=400&height=300&seq=asset-scifi-ui&orientation=landscape',
  },
  {
    id: 5,
    title: '自然环境音效库',
    category: 'sound-effects',
    categoryName: '音效资源',
    downloads: 17800,
    rating: 4.8,
    format: 'WAV/MP3',
    size: '960MB',
    image: 'https://readdy.ai/api/search-image?query=Serene%20nature%20soundscape%20visualization%20with%20forest%20and%20water%20elements%2C%20soft%20green%20and%20warm%20earth%20tones%2C%20ambient%20audio%20concept%2C%20peaceful%20natural%20atmosphere%2C%20clean%20minimalist%20design&width=400&height=300&seq=asset-nature-sound&orientation=landscape',
  },
  {
    id: 6,
    title: '赛博朋克建筑模型包',
    category: 'game-assets',
    categoryName: '游戏素材',
    downloads: 20100,
    rating: 4.7,
    format: 'FBX/OBJ',
    size: '1.8GB',
    image: 'https://readdy.ai/api/search-image?query=Cyberpunk%20city%20building%203D%20models%20showcase%20with%20neon%20lights%2C%20futuristic%20architecture%20on%20dark%20background%2C%20game%20asset%20display%2C%20vibrant%20pink%20and%20teal%20accents%2C%20professional%203D%20design&width=400&height=300&seq=asset-cyberpunk&orientation=landscape',
  },
  {
    id: 7,
    title: '卡通角色动画集',
    category: 'visual-assets',
    categoryName: '视觉素材',
    downloads: 25100,
    rating: 4.5,
    format: 'Spine/DragonBones',
    size: '560MB',
    image: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20character%20animation%20poses%20on%20a%20clean%20warm%20background%2C%20colorful%202D%20game%20sprites%2C%20various%20expressions%20and%20actions%2C%20bright%20and%20cheerful%20design%2C%20game%20development%20assets&width=400&height=300&seq=asset-cartoon-anim&orientation=landscape',
  },
  {
    id: 8,
    title: '地牢探索氛围音乐',
    category: 'music',
    categoryName: '音乐素材',
    downloads: 13400,
    rating: 4.9,
    format: 'MP3/FLAC',
    size: '720MB',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20dungeon%20atmosphere%20with%20warm%20torch%20light%2C%20musical%20notes%20echoing%20in%20ancient%20stone%20corridors%2C%20ambient%20fantasy%20music%20concept%2C%20deep%20shadows%20and%20golden%20highlights&width=400&height=300&seq=asset-dungeon-music&orientation=landscape',
  },
];

export const latestArticles = [
  {
    id: 1,
    title: '2024年游戏音效设计趋势：从8-bit到沉浸式音频',
    excerpt: '随着游戏技术的不断进步，音效设计正在经历一场革命性的变革。从传统的8-bit电子音到如今的空间音频技术，游戏音效已经成为了提升玩家沉浸感的关键元素...',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20game%20audio%20design%20workspace%20with%20headphones%20and%20sound%20equipment%2C%20warm%20ambient%20lighting%2C%20creative%20studio%20atmosphere%2C%20professional%20audio%20production%20setup%2C%20clean%20minimalist%20design&width=600&height=400&seq=article-sound-trend&orientation=landscape',
    author: '音效设计师老王',
    date: '2024-12-15',
    readTime: '8分钟',
    tags: ['音效设计', '行业趋势'],
  },
  {
    id: 2,
    title: '独立游戏开发入门：如何高效利用免费素材资源',
    excerpt: '对于预算有限的独立游戏开发者来说，免费素材资源是项目成功的关键。本文将分享如何在海量素材库中快速找到高质量资源，以及素材的合理使用技巧...',
    cover: 'https://readdy.ai/api/search-image?query=Independent%20game%20developer%20working%20on%20laptop%20with%20colorful%20game%20assets%20displayed%2C%20creative%20workspace%2C%20warm%20lighting%2C%20modern%20minimalist%20desk%20setup%2C%20inspirational%20atmosphere&width=600&height=400&seq=article-indie-dev&orientation=landscape',
    author: '独立游戏人小李',
    date: '2024-12-10',
    readTime: '12分钟',
    tags: ['独立游戏', '开发教程'],
  },
  {
    id: 3,
    title: '像素艺术复兴：为什么2D游戏依然魅力不减',
    excerpt: '在3A大作追求极致画面的今天，像素艺术风格的游戏却依然拥有大量忠实粉丝。从《星露谷物语》到《死亡细胞》，2D像素美学正在经历一场文艺复兴...',
    cover: 'https://readdy.ai/api/search-image?query=Beautiful%20pixel%20art%20game%20scene%20with%20retro%20aesthetic%2C%20colorful%202D%20landscape%20with%20characters%2C%20warm%20sunset%20lighting%2C%20nostalgic%20game%20design%2C%20vibrant%20and%20detailed%20pixel%20graphics&width=600&height=400&seq=article-pixel-art&orientation=landscape',
    author: '美术总监大刘',
    date: '2024-12-05',
    readTime: '6分钟',
    tags: ['像素艺术', '游戏美术'],
  },
];

export const faqs = [
  {
    question: 'aigei 上的素材是否可以商用？',
    answer: 'aigei 上的大部分素材采用 CC0 或类似宽松许可协议，支持个人和商业用途。但部分素材可能有特定的授权要求，建议在下载前查看每个素材的授权说明。对于商业项目，我们推荐使用标注为"可商用"的素材资源。',
  },
  {
    question: '如何快速找到我需要的素材？',
    answer: '您可以通过顶部的搜索栏输入关键词进行搜索，也可以通过分类导航浏览不同类别的素材。我们提供了丰富的筛选选项，包括格式、风格、分辨率等维度，帮助您精准定位所需资源。此外，热门标签和推荐列表也能帮您发现优质内容。',
  },
  {
    question: '素材下载有数量限制吗？',
    answer: '注册用户每天可免费下载50个素材文件，VIP会员则享有无限下载权限。我们还为新注册用户提供了7天的VIP体验期，期间可无限制下载所有素材。',
  },
  {
    question: 'aigei 支持哪些素材格式？',
    answer: '我们支持多种主流游戏开发格式：2D素材支持 PNG、PSD、AI 等格式；3D素材支持 FBX、OBJ、Blend 等格式；音效和音乐支持 WAV、MP3、FLAC、OGG 等格式。所有素材都会标注具体格式信息。',
  },
  {
    question: '如何上传分享我的素材？',
    answer: '登录后，点击右上角的"上传素材"按钮，即可进入上传页面。我们支持批量上传，单个文件最大支持2GB。上传后需要经过审核，通过后您的素材将对所有用户可见。优质素材创作者还可获得平台推荐和收益分成。',
  },
  {
    question: '遇到素材质量问题怎么办？',
    answer: '如果您下载的素材存在质量问题（如文件损坏、与描述不符等），可以通过素材详情页的"举报"按钮反馈。我们的审核团队会在24小时内处理，确认问题后会及时修复或下架相关素材，并为您的账户补偿下载额度。',
  },
];